import React from 'react';
import List from 'housecall-ui/dist/DesignSystem/DataDisplay/List/List';
import ListItem from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem';
import ListSubheader from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListSubheader';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import { isPresent } from 'utils/isPresent';

import TrackedLink from 'components/Common/Link/TrackedLink';

import SearchListItem, { ListItemProps } from './SearchListItem';

const SearchList = ({
  list,
  type,
  moreResultsUrl,
}: {
  list: ListItemProps[];
  type: string;
  moreResultsUrl?: string;
}) => (
  <List
    subheader={
      <ListSubheader>
        <Typography variant="eyebrow" color="textSecondary">
          {type}
        </Typography>
      </ListSubheader>
    }
  >
    {list.map((item: ListItemProps) => (
      <SearchListItem item={item} key={item.object_id} />
    ))}
    {isPresent(moreResultsUrl) && (
      <ListItem>
        <TrackedLink
          href={moreResultsUrl}
          rel="noopener noreferrer"
          color="secondary"
          variant="caption"
          underline="always"
        >
          {`Search all ${type.toLowerCase()}`}
        </TrackedLink>
      </ListItem>
    )}
  </List>
);

export default SearchList;
